import React, { useCallback, useEffect, useState } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import { hikingPath } from '../utils/paths';
import { normalizeClubSport } from '../config/clubSports';
import './HikingClubAdmin.css';

const HikingClubAdmin = () => {
  const { id } = useParams();
  const { user, isAdmin } = useAuth();
  const [club, setClub] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [allowed, setAllowed] = useState(false);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const data = await api.getClubById(id);
      setClub(data);
      const isOwner = user?.id && data.adminUserId === user.id;
      setAllowed(!!(isOwner || isAdmin()));
    } catch (err) {
      setError(err.message || 'Failed to load club');
    } finally {
      setLoading(false);
    }
  }, [id, user?.id, isAdmin]);

  useEffect(() => {
    load();
  }, [load]);

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error-message">{error}</div>;
  if (!club) return <div className="error-message">Club not found</div>;
  if (normalizeClubSport(club.sport) !== 'HIKING') {
    return <Navigate to={`/soccer/clubs/${id}/admin`} replace />;
  }
  if (!allowed) {
    return <Navigate to={hikingPath(`/clubs/${id}`)} replace />;
  }

  return (
    <div className="hiking-club-admin">
      <p className="hiking-club-admin__eyebrow">
        <Link to={hikingPath(`/clubs/${id}`)}>{club.name}</Link>
      </p>
      <h1>Club admin</h1>
      <p>Manage trails, group outings, and shareable hike details.</p>

      <div className="hiking-club-admin__grid">
        <Link to={hikingPath(`/clubs/${id}/trails`)} className="hiking-club-admin__card">
          <h2>Trails</h2>
          <p>Publish trails with distance, elevation, terrain, and trailhead directions.</p>
        </Link>
        <Link to={hikingPath(`/clubs/${id}/outings`)} className="hiking-club-admin__card">
          <h2>Outings</h2>
          <p>Set the meeting spot, start time, pace, and pack list for each group hike.</p>
        </Link>
        <Link to={hikingPath(`/clubs/${id}`)} className="hiking-club-admin__card">
          <h2>Club home</h2>
          <p>Preview what hikers see for upcoming outings and published trails.</p>
        </Link>
      </div>
    </div>
  );
};

export default HikingClubAdmin;
